// extracted by mini-css-extract-plugin
module.exports = {"page-name":"page-name-2NGx1","pageName":"page-name-2NGx1","page-name-input":"page-name-input-1vsFh","pageNameInput":"page-name-input-1vsFh"};